(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'canEdit'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, canEdit) {
        var vm = this;
        vm.canEdit = canEdit;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.setDisable = setDisable;
        vm.sendPasswordReset = sendPasswordReset;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = $state.params.search;
        vm.transition = transition;
        vm.filterRoles = filterRoles;
        vm.filterAttributes = filterAttributes;
        vm.loadAll();

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function setDisable(user, isDisabled) {
            user.disabled = isDisabled;
            User.update(user, reloadUsers, reloadUsers);
        }

        function sendPasswordReset(user) {
            console.log('Sending password reset for user:', user.login); // Debug log
            User.sendPasswordReset({login: user.login}, {}, function(response) {
                AlertService.success('userManagement.passwordReset.success', {email: user.email});
            }, function(error) {
                console.error('Password reset error:', error); // Debug log
                var message = 'userManagement.passwordReset.error';
                if (error.data && error.data.message) {
                    message = error.data.message;
                }
                AlertService.error(message);
            });
        }

        function reloadUsers() {
            vm.loadAll();
            vm.clear();
        }

        function loadAll() {
            User.queryManaged({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                query: vm.searchQuery
            }, onSuccess, onError);
        }

        function onSuccess (data, headers) {
            // Hide anonymous user from user management: it's a required user for Spring Security
            // TODO: do this server-side
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError (error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, disabled: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.searchQuery
            });
        }

        function filterRoles(userAuthorities) {
            return userAuthorities.filter(function(authority) {
                return authority.startsWith('ROLE_');
            })
        }

        function filterAttributes(userAuthorities) {
            return userAuthorities.filter(function(authority) {
                return !authority.startsWith('ROLE_');
            })
        }
    }
})();
